if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.swatchCount = Array.from(this.querySelectorAll('.colour-swatch-links--desktop .swatch')).length;
      this.firstImage = this.querySelector('.product-card__imagePlaceholder');
      this.secondImage = this.querySelector('.product-card__secondImagePlaceholder');
      this.video = this.querySelector('.product-card__videoPlaceholder');

      this.additionalSwatches = this.querySelector('.additional-swatches');
      this.additionalSwatchesTrigger = this.querySelector('.swatch-additional');
      this.additionalSwatchesTriggerBtn = this.querySelector('.swatch-additional button');

      this.titlePriceContainer = this.querySelector('.product-card__titlePrice');
      this.productLabelTag = this.querySelector('.product-card-text-badge');

      this.boundHandleSwatchClick = this.handleSwatchClick.bind(this);
      this.boundHandleAdditionalSwatchesClick = this.handleAdditionalSwatchesClick.bind(this);
      this.quickshopBtns = this.querySelectorAll('.quickshop-btn');
      this.link = this.querySelector('.product-card__link');

      this.badgeData = this.loadBadgeData();
      this.mql = window.matchMedia('(max-width: 991px)');
      this.imgTemplate = `
        <img 
          src="image_src"
          alt="image_alt"
          class="product-card__imagePlaceholder has-icon"
          loading="lazy"
          width="360"
          height="470"
        >
      `;
      this.videoTemplate = `
        <video class="product-card__videoPlaceholder" 
          playsinline="playsinline"
          autoplay="autoplay" 
          loop="loop" 
          preload="none" 
          class="product-card__videoPlaceholder" 
          muted="muted" 
          aria-label="video_alt" 
          poster="video_poster"
        >
          <source 
            src="video_src" 
            type="video/mp4"
          >
          <img 
          src="video_poster"
          >
        </video>
      `;
    }

    loadBadgeData() {
      const badgeScript = this.querySelector('.product-badge-data');
      if (!badgeScript) return null;

      try {
        return JSON.parse(badgeScript.textContent);
      } catch (e) {
        console.error('Failed to parse badge data:', e);
        return null;
      }
    }

    connectedCallback() {
      // const titleLength = this.querySelector('.product-card__titleLink').textContent.length;
      // const titleWidth = this.querySelector('.product-card__titleLink').offsetWidth;

      // if (window.innerWidth < 768) {
      //   if (titleLength >= 21) {
      //     this.classList.add('product-card--showMinHeightMobile');
      //     return;
      //   }
      // } else if (titleWidth && titleWidth < 390) {
      //   if (titleLength >= 32) {
      //     this.classList.add('product-card--showMinHeightDesktop');
      //     return;
      //   }
      // }

      if (this.swatchCount >= 6) {
        this.initSwatchSlider();
      }

      this.querySelectorAll('.swatch:not(.swatch-additional)').forEach((swatch) => {
        swatch.addEventListener('click', this.boundHandleSwatchClick);
      });

      if (this.additionalSwatchesTrigger) {
        this.additionalSwatchesTrigger.addEventListener('click', this.boundHandleAdditionalSwatchesClick);
      }

      if(this.video) {
        this.link.addEventListener('mouseenter', this.stopVideo.bind(this));
        this.link.addEventListener('mouseleave', this.playVideo.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.swatchSlider) {
        this.swatchSlider.destroy();
      }

      this.querySelectorAll('.swatch').forEach((swatch) => {
        swatch.removeEventListener('click', this.boundHandleSwatchClick);
      });

      if (this.additionalSwatchesTrigger) {
        this.additionalSwatchesTrigger.removeEventListener('click', this.boundHandleAdditionalSwatchesClick);
      }
    }

    initSwatchSlider() {
      const prevBtn = this.querySelector('.swiper-btn-prev');
      const nextBtn = this.querySelector('.swiper-btn-next');

      this.swiperEl.dataset.arrowMode = 'forward';

      this.swatchSlider = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        nested: true,
        spaceBetween: 1,
        watchOverflow: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          992: {
            cssMode: false,
            slidesPerView: 6,
            spaceBetween: 8,
            slidesPerGroup: 6,
          },
        },
        on: {
          reachEnd: () => {
            this.swiperEl.dataset.arrowMode = 'backward';
          },
          reachBeginning: () => {
            this.swiperEl.dataset.arrowMode = 'forward';
          },
        },
      });
    }

    stopVideo() {
      if(this.video) {
        this.video.pause();
      }
    }

    playVideo() {
      if(this.video) {
        this.video.play();
      }
    }

    handleSwatchClick(e) {
      const swatch = e.target.closest('.swatch');
      const swatchBtn = swatch.querySelector('button');

      if (!swatchBtn || !this.secondImage) return;

      const hasGlobalDiscount = swatchBtn.hasAttribute('data-has-global-discount');

      if(hasGlobalDiscount === true) {
        const salesBadge = this.querySelector('.sale-price-sale-badge');
        salesBadge.innerHTML = `${swatchBtn.dataset.discountPercentage} off`;
      }

      const url = swatchBtn.dataset.swatchUrl;
      this.link.href = url;

      this.handleUpdatePrice(swatchBtn, swatch);

      if (this.quickshopBtns && this.quickshopBtns.length > 0) {
        this.quickshopBtns.forEach((btn) => {
          btn.dataset.productHandle = swatchBtn.dataset.swatchUrl.split('/products/')[1].split('?')[0];
        });
      }

      this.querySelectorAll('button.is-selected').forEach(btn => btn.classList.remove('is-selected'));
      swatchBtn.classList.add('is-selected');
      const swatchIsVideo = swatchBtn.dataset.swatchIsVideo;

      if(swatchIsVideo === 'true') {
        this.updateVideo(swatchBtn);
      }
      else {
        this.updateFirstImage(swatchBtn);
      }
      this.updateSecondImage(swatchBtn);

      this.updateBadge(swatchBtn);
      this.updateDiscountBadge(swatchBtn);
    }

    createMediaFromTemplate(template, data) {
      if (!this.link || !template) return null;
      const isVideo = template.includes('<video');
      let html;
      if (isVideo) {
        html = template
          .replace('video_src', data.src || '')
          .replace('video_poster', data.poster || '')
          .replace('video_alt', data.alt || '');
      } else {
        html = template
          .replace('image_src', data.src || '')
          .replace('image_alt', data.alt || '');
      }
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      const el = wrapper.firstElementChild;
      if (el) {
        this.link.appendChild(el);
      }
      return el;
    }
    
    // Mirrors snippets/card-image-srcset.liquid: same widths, 360:470 crop.
    // Accepts either a legacy size-suffixed URL (..._360x470_crop_center.jpg?v=1)
    // or a query-param URL (....jpg?v=1&width=360) and rebuilds each candidate
    // as ....jpg?crop=center&height=H&v=1&width=W.
    buildCardSrcset(imageUrl) {
      if (!imageUrl) return '';

      const [path, query = ''] = imageUrl.split('?');
      const basePath = path.replace(/_\d+x\d+(?:_crop_[a-z]+)?(\.[a-z]+)$/i, '$1');
      const baseParams = new URLSearchParams(query);
      baseParams.delete('width');
      baseParams.delete('height');
      baseParams.delete('crop');

      return [360, 540, 720, 1080]
        .map((width) => {
          const height = Math.round((width * 470) / 360);
          const params = new URLSearchParams(baseParams);
          params.set('crop', 'center');
          params.set('height', height);
          params.set('width', width);
          return `${basePath}?${params.toString()} ${width}w`;
        })
        .join(', ');
    }

    updateFirstImage(swatchBtn) {
      const swatchImage = swatchBtn.dataset.swatchImg;
      const swatchImageAlt = swatchBtn.dataset.swatchImgAlt || '';

      if (this.firstImage) {
        this.firstImage.src = swatchImage;
        this.firstImage.srcset = this.buildCardSrcset(swatchImage);
        this.firstImage.alt = swatchImageAlt;
      } else {
        if (this.video) {
          this.video.remove();
          this.video = null;
          this.link.removeEventListener('mouseenter', this.stopVideo);
          this.link.removeEventListener('mouseleave', this.playVideo);
        }
        const data = {
          src: swatchImage,
          alt: swatchImageAlt,
        }
        const img = this.createMediaFromTemplate(this.imgTemplate, data);
        if (img) {
          img.srcset = this.buildCardSrcset(swatchImage);
          this.firstImage = img;
        }
      }
    }

    updateVideo(swatchBtn) {
      const swatchVideo = swatchBtn.dataset.swatchVideo;
      const swatchImage = swatchBtn.dataset.swatchImg;
      const swatchImageAlt = swatchBtn.dataset.swatchImgAlt;

      if(this.video) {
        this.video.querySelector('source').src = swatchVideo;
        this.video.querySelector('img').src = swatchImage;
        this.video.ariaLabel = swatchImageAlt;
        this.video.poster = swatchImage;
        this.video.load();
        this.video.play();
      }
      else {
        if (this.firstImage) {
          this.firstImage.remove();
          this.firstImage = null;
        }
        this.link.addEventListener('mouseenter', this.stopVideo.bind(this));
        this.link.addEventListener('mouseleave', this.playVideo.bind(this));
        const data = {
          src: swatchVideo,
          poster: swatchImage,
          alt: swatchImageAlt,
        }
        const video = this.createMediaFromTemplate(this.videoTemplate, data);
        if (video) this.video = video;
      }
    }

    updateSecondImage(swatchBtn) {
      const swatchSecondImage = swatchBtn.dataset.swatchImgSecond;
      const swatchSecondImageAlt = swatchBtn.dataset.swatchImgSecondAlt;

      this.secondImage.src = swatchSecondImage;
      this.secondImage.srcset = this.buildCardSrcset(swatchSecondImage);
      this.secondImage.alt = swatchSecondImageAlt;
    }

    handleUpdatePrice(el, swatch) {
      if (!this.titlePriceContainer) return;

      const regularPrice = el.dataset.productPrice;
      const compareAtPrice = el.dataset.productCompare;
      const discountedPrice = el.dataset.discountedPrice;
      const discountPercentage = el.dataset.discountPercentage;
      

      let textDiscountedPrice = discountedPrice;

      const discountedPriceRoundedToZero = Math.floor(discountedPrice * 10) % 10 === 0;
      if (discountedPriceRoundedToZero) {
        textDiscountedPrice = parseFloat(discountedPrice).toFixed(0);
      } else {
        textDiscountedPrice = parseFloat(discountedPrice).toFixed(2);
      }

      const isOnSale = this.dataset.onSale;
      const metaDiscountType = swatch.dataset.metaDiscountType;

      const hasCustomSaleStyles = this.titlePriceContainer.classList.contains('custom-sale-styles');
      const customStylesHTML = hasCustomSaleStyles
        ? `<span class="custom-sale-label">Now ${(((compareAtPrice - regularPrice) * 100) / compareAtPrice).toFixed(0)}% off</span>`
        : '';

      if (swatch.dataset.metaDiscountValue && swatch.dataset.metaDiscountValue != 0) {
        this.titlePriceContainer.textContent = '';

        const badgeHTML =
          swatch.dataset.metaBadgeText && swatch.dataset.metaBadgeText.trim() !== ''
            ? `<span class="flash-sale-badge-and-price">
               <span class="flash-sale-badge">
                 ${swatch.dataset.metaBadgeText}
               </span>
             </span>`
            : '';

        let metaDiscountedPrice = regularPrice;

        if (swatch.dataset.metaDiscountType == 'Percentage') {
          metaDiscountedPrice = (regularPrice * (1 - swatch.dataset.metaDiscountValue / 100)).toFixed(2);
        } else {
          metaDiscountedPrice = regularPrice - swatch.dataset.metaDiscountValue;
        }

        this.titlePriceContainer.innerHTML += `
          <span class="card-price-val">$${regularPrice}</span> 
          ${badgeHTML}
          <span class="flash-sale-price">
            $${metaDiscountedPrice} after ${metaDiscountType == 'Percentage' ? `${swatch.dataset.metaDiscountValue}% off` : `$${swatch.dataset.metaDiscountValue} off`} 
          </span>
        `;
      } else if (discountedPrice == 0) {
        if (compareAtPrice == regularPrice || compareAtPrice == 0) {
          this.titlePriceContainer.textContent = `$${regularPrice}`;
        } else if (compareAtPrice != regularPrice && compareAtPrice != 0) {
          this.titlePriceContainer.textContent = '';
          this.titlePriceContainer.innerHTML = `
              <span class='on-sale'>
                <span class='sale-price'> 
                  $${regularPrice}
                  <s>$${compareAtPrice}</s>
                </span>
              </span>
              ${customStylesHTML}
            `;
        }
      } else {
        if (compareAtPrice == regularPrice || compareAtPrice == 0) {
          this.titlePriceContainer.textContent = '';
          if(this.dataset.hideGlobalDiscountRateLanguage != undefined) {
            this.titlePriceContainer.innerHTML = `
              <s>$${regularPrice}</s>
              <div class="global-discount">$${textDiscountedPrice}</div>  
            `;
          }
          else {
            this.titlePriceContainer.innerHTML = `
              <s>$${regularPrice}</s>
              <div class="global-discount">$${textDiscountedPrice} <span class="global-discount-text">after ${discountPercentage} off</span></div>  
            `;
          }
          
        } else {
          this.titlePriceContainer.textContent = '';
          if(this.dataset.hideGlobalDiscountRateLanguage != undefined) {
            this.titlePriceContainer.innerHTML = `
              <span class='on-sale'>
                <span class='sale-price'> 
                  <s>$${compareAtPrice}</s>
                </span>
              </span>
              <div class="global-discount">$${textDiscountedPrice}</div>  
            `;
          }
          else {
            this.titlePriceContainer.innerHTML = `
            <span class='on-sale'>
              <span class='sale-price'> 
                <s>$${compareAtPrice}</s>
                <s>$${regularPrice}</s>
              </span>
            </span>
            <div class="global-discount">$${textDiscountedPrice} <span class="global-discount-text">after ${discountPercentage} off</span></div>  
          `;
          }
          
        }
      }
    }

    updateBadge(swatchBtn) {
      const labelTagText = swatchBtn?.dataset?.swatchBadge || '';
      const productCardTextBadge = this.querySelector('.product-card-text-badge');
      if(productCardTextBadge){
        productCardTextBadge.textContent = labelTagText;
      }
    }
    updateDiscountBadge(swatchBtn){
      const discountBadgeText = swatchBtn?.dataset?.discountBadge || '';
      const discountBadge = this.querySelector('.bulk-discount__badge-slider');
      if(discountBadge){
        discountBadge.textContent = discountBadgeText;
      }
    }

    handleAdditionalSwatchesClick(e) {
      if (!this.additionalSwatches) return;

      if (this.additionalSwatches.classList.contains('expanded')) {
        this.additionalSwatches.style.maxHeight = '0px';
        this.additionalSwatches.classList.remove('expanded');
        this.additionalSwatchesTriggerBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.additionalSwatches.style.maxHeight = this.additionalSwatches.scrollHeight + 'px';
        this.additionalSwatches.classList.add('expanded');
        this.additionalSwatchesTriggerBtn.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('product-card', ProductCard);
}
